import {initializeApp} from 'firebase/app';
import {Page} from '../pages/page';
import {getEnvConfig} from './environment';
import {TranslateLegacy} from './translateLegacy';
import {ITranslateService} from './translateService';

export class Base {
  public static async init({
    translateService,
  }: {
    translateService: ITranslateService;
  }): Promise<void> {
    const envir = getEnvConfig();
    initializeApp(envir.firebaseConfig);

    console.log(
      'simpleclub integration loaded.',
      'for',
      envir.apiBaseUrl,
      'PROD:',
      envir.production,
    );

    try {
      await translateService.initialize('de');
      await TranslateLegacy.initialize('de');
    } catch (e) {
      console.warn('translation fetch error', e);
    }
  }

  public static renderPageOnReady(page: Page): void {
    this.onLoaded(() => {
      page.renderPre.bind(page)();
      page.render.bind(page)();
    });
  }

  public static onLoaded(fn: () => void): void {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        fn();
      });
    }
  }
}
